import type { XY } from "../xy";
import { XYEffect } from "./xyEffect";

export interface LootPickupItem {
	pickupKey: string;
	amount: number;
	isInfinite: boolean;
}

export class LootPickupEffect extends XYEffect {
	static key = "LootPickupEffect";

	constructor(
		xy: XY,
		public readonly items: LootPickupItem[],
	) {
		super(xy);
		this.setUnbounded(true);
	}
}
